export const GetProjectId = () =>{
    if(process.env.REACT_APP_ENV=='Production') return process.env.REACT_APP_PROJECT_ID_PROD; else return process.env.REACT_APP_PROJECT_ID_DEV;
}


export const GetBaseUrl = () =>{
    if(process.env.REACT_APP_ENV=='Production') return process.env.REACT_APP_API_BASE_PROD; else return process.env.REACT_APP_API_BASE_DEV;
}